<template>
  <div class="uk-background-darkest uk-section uk-section-medium uk-light" v-if="!$apollo.loading && !!entry">

      <div class="uk-container uk-container-large">

          <ul class="uk-breadcrumb uk-margin-medium-bottom uk-visible@l">
              <li><router-link to="../.." class="text-orange"><label>STUDENT COMPETITIONS</label></router-link></li>
              <li><router-link to="..">{{competition.menuTitle}}</router-link></li>
              <li><span>{{entry.title}}</span></li>
          </ul>

          <div class="uk-flex uk-grid-large" uk-grid>
              <div class="uk-width-1-3@l">

                  <h4 class="text-green uk-margin-remove-bottom" v-if="entry.prize && entry.prize.id > 0"><label>${{parseInt(entry.prize.prize).toLocaleString('en-US')}} {{entry.prize.title}}</label></h4>

                  <div class="uk-flex uk-grid-divider" uk-grid>
                      <div class="uk-width-2-5@m uk-width-1-1@l">

                          <router-link :to="competition.link"><label class="uk-text-muted">{{entry.year ? `${entry.year.title} ` : ''}}{{competition.menuTitle}}</label></router-link>
                          <h5 class="uk-margin-remove-bottom" v-if="entry.medium && entry.medium.title">{{entry.medium.title}}</h5>
                          <h1>{{entry.title}}</h1>
                          <p class="text-white uk-text-lead" v-if="entry.name"><b>{{entry.name}}</b>{{ entry.grade ? `, ${entry.grade}` : ''}}</p>

                          <p class="text-white" v-if="!!entry.teacherName">
                              <label>Teacher:</label><br/>
                              <span v-html="entry.teacherName"></span>
                              <template v-if="!!entry.teacherTitle">
                                  <br/>
                                  <em>{{entry.teacherTitle}}</em>
                              </template>
                          </p>

                      </div>
                      <div class="uk-width-3-5@m uk-width-1-1@l">
                          <h4 v-if="entry.quote"><em class="text-light-blue">{{entry.quote}}</em></h4>
                          <p v-if="entry.description">{{entry.description}}</p>

                          <a :href="entry.externalLink" target="_blank" v-if="entry?.externalLink" class="text-blue uk-text-uppercase">{{ entry.externalLinkLabel || "READ MORE" }} <span class="uk-icon" uk-icon="chevron-right"></span></a>
                      </div>
                  </div>

              </div>


               <div class="uk-width-2-3@l uk-width-1-1@m uk-first-column">
                   <div class="flex-video widescreen" v-if="entry.video && entry.video.id > 0">
                       <div v-html="entry.video.embedCode"></div>
                   </div>
                   <img :src="entry.image.large" class="uk-margin-top" :alt="entry.title" v-else-if="entry.image && entry.image.large" />

               </div>
          </div>


      <!-- <div class="uk-section uk-section-medium">
          <div class="uk-container uk-container-small">
              <h1><b>Meet the Hero:</b> {{project.HeroName}}</h1>
              <div v-html="project.StorytellersText"></div>
          </div> -->
      </div>

  </div>
</template>

<script>
import gql from 'graphql-tag'

// GraphQL query
const readEntryQuery = gql`
    query($urlSegment: String!) {
      readOneCompetitionEntry(filter: { urlSegment: { eq: $urlSegment }}){
        id
        title
        description
        externalLink
        externalLinkLabel
        grade
        name
        quote
        title
        teacherName
        teacherTitle
        year {
            title
        }
        medium {
            title
        }
        prize {
            id
            title
            prize
        }
        video {
            id
            embedCode
        }
        image {
            id
            large
        }
      }
    }
`

export default {
    inject: ['state'],
    data() {
        return {
            entry: {}
        }
    },
    props: ['competition'],
    apollo: {
        entry: {
            // GraphQL query
            query: readEntryQuery,
            variables() {
                return {
                    urlSegment: this.$route.params.entryId
                }
            },
            update(data) {
                this.state.setMetaTitle(`${data?.readOneCompetitionEntry.title} | ${this?.competition.title}`)
                return data.readOneCompetitionEntry
            }
        }
    }
}
</script>
